import { Navigate, useParams } from 'react-router-dom'
import { FullChat } from '../widgets/chat/fullChat.tsx'
import { demoLessonTag, HelpLessonTag } from '../shared/api/chatApi.ts'
import { urls } from '../shared/urls.ts'

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
type RouteParams = {
  tag: string
}

export function ChatPage() {
  const params = useParams<RouteParams>()
  const tag = params.tag ?? demoLessonTag
  if (HelpLessonTag(tag)) return <Navigate to={urls.main} replace />
  return <FullChat tag={tag} />
}
